export const normalizeArticleGroupPart = value => String(value ?? '')
  .trim()
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-z0-9]/g, '');

let localArticleGroupSequence = 0;

// UI-only identity: keeps a newly added lot with its article before the
// operator has entered a name, code, or persistent article_id.
export const createReceiptArticleGroupId = () =>
  `receipt-article-${Date.now().toString(36)}-${(++localArticleGroupSequence).toString(36)}`;

export const groupReceiptItemsByArticle = (items = [], supplier = '') => {
  const rows = Array.isArray(items) ? items : [];
  const supplierKey = normalizeArticleGroupPart(supplier);
  const groupsByKey = new Map();

  rows.forEach((item, index) => {
    const row = item && typeof item === 'object' ? item : {};
    const articleId = String(row.article_id ?? '').trim();
    const localArticleGroupId = String(row._article_group_id ?? '').trim();
    const codeKey = normalizeArticleGroupPart(row.product_code);
    const nameKey = normalizeArticleGroupPart(row.product_name);
    const identity = localArticleGroupId
      ? `local:${localArticleGroupId}`
      : articleId
        ? `article:${articleId}`
        : codeKey
          ? `code:${supplierKey}:${codeKey}`
          : nameKey
            ? `name:${supplierKey}:${nameKey}`
            : `row:${index}`;

    let group = groupsByKey.get(identity);
    if (!group) {
      group = {
        key: identity,
        indexes: [],
        type: localArticleGroupId ? 'local' : articleId ? 'article' : codeKey ? 'code' : nameKey ? 'name' : 'row',
        supplierKey,
        nameKeys: new Set(),
      };
      groupsByKey.set(identity, group);
    }
    if (nameKey) group.nameKeys.add(nameKey);
    group.indexes.push(index);
  });

  const groups = [...groupsByKey.values()];
  const codedGroups = groups.filter(group => group.type === 'code');
  const merged = groups.filter(group => group.type !== 'name');

  groups.filter(group => group.type === 'name').forEach(group => {
    // OCR can miss the code on one lot. Attach a name-only row only when that
    // name points to exactly one coded article for this supplier.
    const candidates = codedGroups.filter(candidate =>
      candidate.supplierKey === group.supplierKey
      && [...group.nameKeys].some(name => candidate.nameKeys.has(name))
    );
    if (candidates.length === 1) {
      candidates[0].indexes.push(...group.indexes);
    } else {
      merged.push(group);
    }
  });

  return merged
    .map(group => ({ key: group.key, indexes: group.indexes.sort((a, b) => a - b) }))
    .sort((a, b) => a.indexes[0] - b.indexes[0]);
};
